import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { Company } from '@/modules/company/models/Company';
import { User } from '@/modules/user/models/User';
import { StripeCoupon } from '@/modules/billing/models/stripe/StripeCoupon';
import { BillingPlanMapping } from '@/modules/billing/models/BillingPlanMapping';
import { SelfServeBillingPlanForm } from '@/modules/estate/models/SelfServeBillingPlanForm';
import { PartnershipInvitationType } from '@/modules/partnershipinvitation/constants/PartnershipInvitationType';

export class PartnershipInvitation extends BaseEntityModel {
  id?: number;
  type?: PartnershipInvitationType;
  token: string;
  companyId?: number;
  jurisdictionId?: number;
  discountKey?: string;
  saasBilling: boolean;
  isEmployee: boolean;
  billingPlanMappingId?: number;
  billingPlanMapping?: Relationship<BillingPlanMapping> | null;
  showAdvisorConsentRequest: boolean;
  createdByUserId?: number;
  billingPlan?: SelfServeBillingPlanForm;
  company?: Relationship<Company>;
  user?: Relationship<User> | null;
  createdByUser: Relationship<User>;

  /**
   * set by loading independently, not saved
   */
  coupon?: StripeCoupon;

  constructor(model: Partial<PartnershipInvitation> = {}) {
    super(model);

    this.id = model.id;
    this.type = model.type ? (model.type as PartnershipInvitationType) : undefined;
    this.token = model.token as string;
    this.companyId = model.companyId;
    this.discountKey = model.discountKey;
    this.saasBilling = model.saasBilling ?? false;
    this.billingPlanMappingId = model.billingPlanMappingId;
    this.billingPlanMapping = BillingPlanMapping.mapModelOrNull(model.billingPlanMapping);
    this.isEmployee = model.isEmployee ?? false;
    this.showAdvisorConsentRequest = model.showAdvisorConsentRequest ?? false;
    this.createdByUserId = model.createdByUserId;
    this.company = Company.mapModel(model.company);
    this.user = User.mapModelOrNull(model.user);
    this.createdByUser = User.mapModel(model.createdByUser);
  }
}
